module.exports = __webpack_public_path__ + "static/media/grill.993acd5e.png";